const contactData = [
  {
    name: 'email',
    faIcon: 'fa-solid fa-envelope',
    url: 'mailto:tramngoc1402@gmail.com?Subject=From%20your%20portfolio',
  },
  {
    name: 'phone',
    faIcon: 'fa-solid fa-phone',
    url: 'tel:+358449513040',
  },
  {
    name: 'github',
    faIcon: 'fa-brands fa-github',
    url: 'https://github.com/tramnguyenhere',
  },
  {
    name: 'linkedin',
    faIcon: 'fa-brands fa-linkedin',
    url: 'https://www.linkedin.com/in/tramnguyenhere/',
  },
];

export default contactData;
